import { useEffect } from 'react'
import { useSignal, batch } from '@preact/signals-react'
import { postSubmit } from '@ui-seeker/utils'

import { isLoadingCommonFilters, isSystemBusy } from '@signals'
import { BACKEND_APIS } from '@constants'
import { reloadSkuGroupFilters } from '../../@signals'


export default function useSkuGroupTableFilters() {
    const data = useSignal([])
    const isLoading = useSignal(false)

    const load = () => {
        isLoading.value = true
        postSubmit(`${BACKEND_APIS.MANAGEMENT}/sku-group/context`, {})
            .then(res => {
                data.value = res
                isLoading.value = false
            })
            .catch(() => {
                isSystemBusy.value = true
                isLoading.value = false
            })
    }

    useEffect(() => {
        if (isLoadingCommonFilters.value) batch(() => {
            load()
            isLoadingCommonFilters.value = false
        })
    }, [isLoadingCommonFilters.value])

    useEffect(() => {
        if (reloadSkuGroupFilters.value) load()
    }, [reloadSkuGroupFilters.value])

    return {
        data: data.value,
        isLoading: isLoading.value
    }
}
